import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppContext from "../../../../../../AppContext/AppContext";
import { ITEM_COLLECTIONS_API } from "../../../../../../Utilities/APIs/APIs";
import useAxiosInstance from "../../../../../../Utilities/Hooks/useAxiosInstance";
import Modal from "../../../../../Partials/Elements/Modal/Modal";
import CreateButton from "../../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDashboardBoilerplate/CRUDHeader/CreateButton/CreateButton";
import DeleteButton from "../../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/DeleteButton/DeleteButton";
import EditButton from "../../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/EditButton/EditButton";
import ViewButton from "../../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton";
import CRUDTable from "../../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable";
import ShortTextCell from "../../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";
import CRUDTableHeader from "../../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import CRUDTableRow from "../../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow";
import CreateItemCollections from "./CreateItemCollections";

// import CreateCollections from "./CreateCollections";
// import DeleteItem from "../../../../Partials/Layouts/DeleteItem/DeleteItem";
// import ViewCollections from "./ViewCollections";
// import UpdateCollections from "./UpdateCollections";

function ItemCollections() {
  const { employee } = useContext(AppContext);
  const [itemCollections, setItemsCollections] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [targetID, setTargetID] = useState(null);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false);
  const [toggleFetch, setToggleFetch] = useState(false);

  const { parentID } = useParams();

  const axiosInstance = useAxiosInstance();

  useEffect(() => {
    async function fetchAndSetCollections() {
      const { data } = await axiosInstance.get(ITEM_COLLECTIONS_API + parentID);
      setItemsCollections(data);
    }
    fetchAndSetCollections();
  }, [toggleFetch, axiosInstance, parentID]);

  function handleClose() {
    setShowModal(false);
    setShowCreateForm(false);
    setShowViewSection(false);
    setShowUpdateForm(false);
    setShowDeleteSection(false);
  }

  function triggerFetch() {
    setToggleFetch((prevState) => !prevState);
  }

  return (
    <>
      <div className="crud_holder">
        <div className="body_header">
          <h1 className="heading">{`Collection Items (${itemCollections?.length} in total)`}</h1>
          <CreateButton
            screenTopicSingular="Collection Item"
            setShowModal={setShowModal}
            setShowCreateForm={setShowCreateForm}
          />
        </div>
        <CRUDTable>
          <CRUDTableHeader>
            <CRUDth th="Name" />
            <CRUDth th="Description" />
            <CRUDth th="Actions" />
          </CRUDTableHeader>
          <tbody>
            {itemCollections?.map((itemCollection) => (
              <CRUDTableRow key={itemCollection?._id}>
                <ShortTextCell text={itemCollection?.name} />
                <ShortTextCell text={itemCollection?.description} />

                <td className="action_button_cell">
                  <ViewButton
                    setShowModal={setShowModal}
                    setShowViewSection={setShowViewSection}
                    targetID={itemCollection._id}
                    setTargetID={setTargetID}
                  />
                  <EditButton
                    setShowModal={setShowModal}
                    setShowUpdateForm={setShowUpdateForm}
                    targetID={itemCollection._id}
                    setTargetID={setTargetID}
                  />
                  <DeleteButton
                    setShowModal={setShowModal}
                    setShowDeleteSection={setShowDeleteSection}
                    targetID={itemCollection?._id}
                    setTargetID={setTargetID}
                  />
                </td>
              </CRUDTableRow>
            ))}
          </tbody>
        </CRUDTable>
      </div>
      {showModal && (
        <Modal
          view
          handleClose={handleClose}
          modalHeading={
            (showCreateForm && `Create Collection`) ||
            (showUpdateForm && `Update Collection`) ||
            (showDeleteSection && `Delete Collection`)
          }
        >
          {showCreateForm && (
            <CreateItemCollections
              employee={employee}
              setShowCreateForm={setShowCreateForm}
              setShowModal={setShowModal}
              triggerFetch={triggerFetch}
            />
          )}
          {/* {showUpdateForm && (
            <UpdateCollections
              employee={employee}
              targetID={targetID}
              setShowUpdateForm={setShowUpdateForm}
              setShowModal={setShowModal}
              triggerFetch={triggerFetch}
            />
          )} */}

          {/* {showDeleteSection && (
            <DeleteItem
              api={MANAGE_COLLECTIONS_API}
              targetID={targetID}
              employee={employee}
              setShowModal={setShowModal}
              setShowDeleteSection={setShowDeleteSection}
              hasName
              triggerFetch={triggerFetch}
            />
          )} */}
        </Modal>
      )}

      {/* {showModal && showViewSection && (
        <Modal
          view
          handleClose={handleClose}
          modalHeading={showViewSection && `View Collection`}
        >
          <ViewCollections targetID={targetID} employee={employee} />
        </Modal>
      )} */}
    </>
  );
}

export default ItemCollections;
